

import React, { useState, useEffect } from 'react';


// Shared
import eventBus from '../../../shared/eventBus';

import { TextField, InputAdornment } from '@material-ui/core';

// Hooks
import useMounted from '../../../hooks/useMounted';

export default function PriceInput({
  inputRef,
  className,
  variant,
  name,
  label,
  fullWidth,
  required,
  disabled,
  value,
  onChange,
  priceType
}) {
    
    // If the component is mounted
    const mounted = useMounted();

    // Field value
    const [value_, setValue] = useState('');

    useEffect(() => {
  
        if(mounted.current) {         
            setValue(value);
        }   
  
    }, [mounted, value, setValue]);

    useEffect(() => {
  
        eventBus.on('priceVersionRestored_init', (data_) => {
          if(mounted.current) {  
            // set the value of the input       
            setValue(data_.versionData[priceType]);
            // trigger the event
            // to close the modal and show
            // the snackbar message to the user
            eventBus.dispatch('priceVersionRestored');
          }    
        });
  
    }, [mounted, priceType]);

    return(
        <>
            <TextField
                inputRef={inputRef}
                className={className}
                variant={variant}
                fullWidth={fullWidth}
                name={name}
                label={label}
                required={required}
                disabled={disabled}
                value={value_}
                onChange={onChange}
                inputProps={{ pattern: '[0-9,.]{1,12}', maxLength: 12 }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">$</InputAdornment>
                    )
                }}
            />
        </>
    )

}